import * as React from "react";
import {
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@material-ui/core";
import ClientActionItemListRow from "../components/ClientActionItemListRow";
import {Proposal} from "../model/proposal";
import {useActions} from "../actions";
import * as AccountActions from "../actions/account";
import * as AwsActions from "../actions/aws";
import * as Actions from "../actions/enrollment";
import { AccountType, ClientDocumentType, GWTVersionEnum, GIFTOR_PORTAL } from "../constants";
import {ClientDocsInterface} from "../model/documents";
import {isDebug, pez, va} from "../utils/commonUtils";
import {ProposalDialog} from "../components/ProposalDialogs";
import RequestModification from "./client/ClientProfile/component/modals/RequestModification";
import RequestDocuments from "./client/ClientProfile/component/modals/RequestDocuments";


function ClientActionItemsList(props: any) {
    let {
        actionItemsList,
        headRows,
        setRefreshPage
    } = props;

    let actionItemsListData: any = actionItemsList.rows && actionItemsList.rows.length > 0 && actionItemsList.rows.map((row: any) => {
        return row;
    });

    const [requestModification, setRequestModification] = React.useState(false);
    const [activeProposalTab, setActiveProposalTab] = React.useState(0);
    const [enableActions, setEnableActions] = React.useState(true);
    const [openProposalPdf, setOpenProposalPdf] = React.useState<Proposal[]>([] as Proposal[]);
    const [viewApproveProposal, setViewApproveProposal] = React.useState(false);
    const [paymentFrequency, setPaymentFrequency] = React.useState<string>("");
    const [actionId, setActionId] = React.useState(0);
    const [callingFromParent, setCallingFromParent] = React.useState(false);
    const [enrollmentId, setEnrollmentId] = React.useState("");
    const [clientPolicyId, setClientPolicyId] = React.useState<string>("");
    const [requestDocuments, setRequestDocuments] = React.useState(false);

    const accountActions = useActions(AccountActions);
    const awsActions = useActions(AwsActions);
    const enrollmentActions = useActions(Actions);

    const handleCloseRm = async () => {
        setRequestModification(false);
        setRequestDocuments(false)

    };

    const cancelProposal = () => {
        setViewApproveProposal(false);
        setOpenProposalPdf([]);
        setActiveProposalTab(0);
        setActionId(0);
    };

    const handleClose = async () => {
        await accountActions.getFreshDataToRefreshReduxState();
    };
    const refreshList = async () => {
        setRefreshPage(Math.random());
    }
    // TODO NIWD-453
    const approveProposal = async (actionId?: number) => {
        await enrollmentActions.updateReviewProposalActionItemGen1({enrollmentId, actionId});
        setRefreshPage(Math.random());
        return cancelProposal();
    };

    const handleRequestModification = (eId?:string) => {
        setRequestModification(!requestModification);
        eId && setEnrollmentId(eId);
    };

    // TODO use common getEnrollmentAdminProposalUrl
    const getEnrollmentAdminProposalUrl = async (eId: string, adminProposal: string, gwtVersion: number) => {
        let file = adminProposal.split(".");
        let fileType = file[file.length - 1].toUpperCase();
        const contentType = (fileType == "PDF") ? ("text/pdf") : ("image/*");
        let queryObj = {
            gwtParent: gwtVersion === GWTVersionEnum.Two,
            objectName: adminProposal,
            contentType: contentType,
        };
        return awsActions.getSecureUrl(eId, queryObj, true);
    };

    const viewProposal = async (id: number, eId: string, status: number, clientPolicyId: string, paymentFrequency: string, gwtVersion: number) => {
        isDebug() && console.log("viewProposal", {actionItemId: id, enrollmentId: eId, status, clientPolicyId});
        const documents: any[] = await accountActions.getClientDocumentByType(clientPolicyId, ClientDocumentType.ADMIN_PROPOSAL);
        const proposalArr: Proposal[] = [];
        for (let i = 0; i < documents.length; i++) {
            const proposalDocument = documents[i] as ClientDocsInterface;
            const url = await getEnrollmentAdminProposalUrl(eId, pez(proposalDocument.path), gwtVersion);
            proposalArr.push({name: proposalDocument.name, url: url});
        }
        setActiveProposalTab(0);
        setClientPolicyId(clientPolicyId)
        setOpenProposalPdf(proposalArr);
        setEnrollmentId(eId);
        setActionId(status === 1 ? 0 : id);
        setPaymentFrequency(paymentFrequency || "annual");
    };


    const viewDocumentChange = async (eId: string, clientPolicyId: string) => {
        setClientPolicyId(clientPolicyId)
        setEnrollmentId(eId);
    }

    const getActionName = (account: any) => {
        return account.actionRequired;
    };

    return (
            <React.Fragment>
                <TableHead>
                    <TableRow>
                        {
                            headRows.map((row: any, idx: number) => (
                                    <TableCell key={`${idx}-${row.id}`}  data-key={`${idx}-${row.id}`} padding={"default"}>
                                        {row.label}
                                    </TableCell>
                            ))
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                            (!actionItemsListData || actionItemsListData.length === 0) &&
                            <TableRow>
                                <TableCell className="textLeft" colSpan={headRows.length}>
                                    No Action list
                                </TableCell>
                            </TableRow>
                    }

                    {
                            actionItemsListData && actionItemsListData.map((actionItem: any) => {
                                return (
                                        <ClientActionItemListRow
                                                refreshList={refreshList}
                                                actionItem={actionItem}
                                                history={props.history}
                                                getActionName={getActionName}
                                                onViewProposal={viewProposal}
                                                setRequestDocuments={setRequestDocuments}
                                                viewDocumentChange={viewDocumentChange}
                                                handleRequestModification={handleRequestModification}
                                                setCallingFromParent={setCallingFromParent}
                                        />
                                );
                            })
                    }
                </TableBody>

                {
                        !!(va(openProposalPdf)) &&
                        <ProposalDialog
                                activeProposalTab={activeProposalTab}
                                approvalVal={actionId}
                                approveProposal={approveProposal}
                                clientPolicyId={clientPolicyId}
                                enableActions={enableActions}
                                handleRequestModification={handleRequestModification}
                                modificationVal={null}
                                onClose={handleClose}
                                onRejectProposal={cancelProposal}
                                openProposalPdf=""
                                paymentFrequency={paymentFrequency}
                                proposalPdf={openProposalPdf}
                                setActiveProposalTab={setActiveProposalTab}
                                setEnableActions={setEnableActions}
                                setViewApproveProposal={setViewApproveProposal}
                                title="Gen2 Client Proposal"
                                viewApproveProposal={viewApproveProposal}
                                setCallingFromParent={setCallingFromParent}
                        />
                }

                {
                        requestModification &&
                        <RequestModification
                                enrollmentId={enrollmentId}
                                handleClose={handleCloseRm}
                                open={requestModification}
                                callingFromParent={callingFromParent}
                                role={AccountType.Individual}
                        />
                }

                {
                    <RequestDocuments
                        enrollmentId={enrollmentId}
                        handleClose={handleCloseRm}
                        open={requestDocuments}
                        refreshList={refreshList}
                    />
                }
            </React.Fragment>
    );
}

export default ClientActionItemsList;